import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatButtonModule } from '@angular/material/button'
import { RouterModule } from '@angular/router'
import { IconComponent } from './icon.component'
import { MatIconModule } from '@angular/material/icon'
import { IconLargeDirective, IconMediumDirective, IconSmallDirective, IconXLargeDirective } from './icon.directive'

@NgModule({
  declarations: [
    IconComponent,
    IconSmallDirective,
    IconMediumDirective,
    IconLargeDirective,
    IconXLargeDirective,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
  ],
  exports: [
    IconComponent,
    IconSmallDirective,
    IconMediumDirective,
    IconLargeDirective,
    IconXLargeDirective,
  ],
})
export class IconModule { }
